/**
 *
 * Schedule Demo
 *
 */

import React, {Component} from 'react';
import Helmet from 'react-helmet';
import FormValidation from 'tcomb-form';

//lib
import AppAPI from '../lib/api';
import AppUtil from '../lib/util';

// Components
import Loading from '../components/general/Loading';
import Error from '../components/general/Error';
import FormView from '../components/general/FormView';

/* Component ==================================================================== */
class ScheduleDemo extends Component {

  sendMessage = (credentials) => {
    if (credentials) {
      this.setState({form_values: credentials}, () => {
        this.setState({resultMsg: {status: 'One moment...'}});
        AppAPI.beta.post('', {
          'name': credentials.Name,
          'email': credentials.Email,
          'phone': credentials.Phone,
          'company': credentials.Company,
          'campaign': 1
        })
          .then(() => {
            this.setState({resultMsg: {success: 'Success'}},
              () => {
                setTimeout(() => {
                  this.setState({resultMsg: {status: ''}, formSuccess: true});
                }, 500);
              });
          })
          .catch((err) => {
            const error = AppAPI.handleError(err);
            this.setState({resultMsg: {error}});
          });
      });
    }
  };

  render = () => {

    const {loading, form_fields, form_values, options, error, resultMsg, formSuccess} = this.state;


    if (loading) return <Loading/>;
    if (error) return <Error text={error}/>;

    return (
      <div className="index screen-container">
        <Helmet>
          <title>Schedule a Demo</title>
        </Helmet>

        <div className={'main-container container'}>
          <div className={'row justify-content-md-center'}>
            <div className={'col-sm-12 col-lg-8 col-md-10'}>

            </div>
          </div>

          <div className={'row justify-content-md-center'}>
            <div className={'col-sm-12 col-lg-8 col-md-10'}>
              <h1 className={'text-center'}>See it in Action</h1>
              <p className={'lead text-center'}>The closest you can be to see how Renzo can change the way you work.</p>
              <div className={'spacer-20'}/>
            </div>
          </div>
          <div className={'row justify-content-md-center'}>
            <div className={'col-sm-12 col-lg-10 col-md-10'}>
              <div className={'spacer-20'}/>
              <div className={'row'}>


                <div className={'col-sm-12 col-md-6'}>
                  <p>Thank you for your interest in Renzo. Drop your contact info and we will provide a free demo tailored for your business.</p>

                  <hr/>
                  <p>You will learn how you can : </p>
                  <ul className="list-unstyled">
                    <li className="">
                      <span className={'fas fa-check green-cl'}/>
                      <h6 className={'d-inline-block p-1 mx-1'}>Cut times on most repeated tasks.</h6>
                    </li>

                    <li className="">
                      <span className={'fas fa-check green-cl'}/>
                      <h6 className={'d-inline-block p-1 mx-1'}>Delegate tasks across departments.</h6>
                    </li>

                    <li className="">
                      <span className={'fas fa-check green-cl'}/>
                      <h6 className={'d-inline-block p-1 mx-1'}>Manage Payments.</h6>
                    </li>

                    <li className="">
                      <span className={'fas fa-check green-cl'}/>
                      <h6 className={'d-inline-block p-1 mx-1'}>Manage day to day expenses.</h6>
                    </li>

                  </ul>

                </div>

                <div className={'col-sm-12 col-md-6 border-left'}>
                  {formSuccess ?
                    <div>
                      <div className={'p-3 mt-3 mb-0 text-center'}>
                        <div className={'col-md-12 p-lg-2'}>
                          <h1><span className={'fas fa-check-circle green-cl'}/> Thank you. </h1>
                          <p>We have received your demo request.</p>
                          <p>One of our representatives will contact you shortly to schedule your demo.</p>
                        </div>
                      </div>
                    </div> :
                    <FormView
                      formFields={form_fields}
                      formValues={form_values}
                      formOptions={options}
                      formAction={this.sendMessage}
                      formActionName={'Schedule Now'}
                      statusMsg={resultMsg}
                      colType={1}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: false,
      resultMsg: {
        status: '',
        success: '',
        error: ''
      },
      form_fields: FormValidation.struct({
        Name: FormValidation.String,
        Company: FormValidation.maybe(FormValidation.String),
        Email: AppUtil.validEmail,
        Phone: AppUtil.validPhone
      }),
      form_values: {},
      options: {
        fields: {
          Company: {
            label: 'Company/Organization (Optional)'
          },
          Phone: {
            help: 'International Format.'
          }
        }
      },
      formSuccess: false
    };
  }

}

export default ScheduleDemo;


// WEBPACK FOOTER //
// ./src/containers/ScheduleDemo.js